export default {
	users(state) {
		return state.users
	},
}
